import http from '@/libs/http'

export function doLogin (username, password) {
  return http.post('crm/token', { username, password })
}
